export default __webpack_public_path__ + "static/media/birria.82fb453c.jpeg";